import React, { JSX, useState } from 'react';
import QuestionPage from './QuestionPage';
import {  QuizResults } from '../../Interfaces/QuizModel';
import { MainQuizProps } from '../../Interfaces/ComponentProps';
import FinishPage from './FinishPage';
import DashboardPage from './DashboardPage';

const MainQuiz: React.FC<MainQuizProps> = ({ quiz, progressId, username, onClose }) => {
  const [currentPage, setCurrentPage] = useState<'question' | 'finish' | 'dashboard'>('question');
  const [quizResults, setQuizResults] = useState<QuizResults | null>(null);

  // Handle quiz completion
  const handleQuizComplete = (results: QuizResults): void => {
    setQuizResults(results);
    setCurrentPage('finish');
  };
  

  // Handle view scoreboard
  const handleViewScoreboard = (): void => {
    setCurrentPage('dashboard');
  };

  // Handle back to finish page from dashboard
  const handleBackToFinish = (): void => {
    setCurrentPage('finish');
  };

  // Render the appropriate page based on current state
  const renderPage = (): JSX.Element => {
    switch (currentPage) {
      case 'question':
        return (
          <QuestionPage
            quiz={quiz}
            progressId={progressId}
            username={username}
            onComplete={handleQuizComplete}
            onClose={onClose}
          />
        );
      case 'finish':
        return (
          <FinishPage
            results={quizResults}
            username={username}
            progressId={progressId}
            onViewScoreboard={handleViewScoreboard}
            onClose={onClose}
          />
        );
      case 'dashboard':
        return (
          <DashboardPage
            results={quizResults}
            username={username}
            onBack={handleBackToFinish}
            onClose={onClose}
          />
        );
      default:
        return (
          <QuestionPage
            quiz={quiz}
            progressId={progressId}
            username={username}
            onComplete={handleQuizComplete}
            onClose={onClose}
          />
        );
    }
  };

  return <>{renderPage()}</>;
};

export default MainQuiz;